export function isCelularValidoBR(telefone?: string | null): boolean {
  if (!telefone) return false;

  const numero = telefone.replace(/\D/g, '');

  const regex = /^[1-9]{2}9\d{8}$/;

  return regex.test(numero);
}
